import { Link } from 'react-router-dom';
import { useState } from 'react';
import AFCteamLogos from '../../assets/AFCteamLogos';
import afcLogo from '../../assets/afc-logo.png';
import '../../css/NFLhomepage.css';

const AFChomePage = () => {
    const [showPopup, setShowPopup] = useState(false);
    const [standingsView, setStandingsView] = useState('division');

    const getTeamPath = (teamName) => {
        return `/sports/football/afc/teams/${teamName
            .toLowerCase()
            .replace(/\./g, '')
            .replace(/\s+/g, '-')}`;
    };

    const afcDivisions = [
        {
            division: "AFC East",
            teams: [
                { rank: 2, name: "New England Patriots", record: "14-3" },
                { rank: 6, name: "Buffalo Bills", record: "12-5" },
                { rank: 10, name: "Miami Dolphins", record: "7-10" },
                { rank: 15, name: "New York Jets", record: "3-14" }
            ]
        },
        {
            division: "AFC North",
            teams: [
                { rank: 4, name: "Pittsburgh Steelers", record: "10-7" },
                { rank: 9, name: "Baltimore Ravens", record: "8-9" },
                { rank: 11, name: "Cincinnati Bengals", record: "6-11" },
                { rank: 13, name: "Cleveland Browns", record: "5-12" }
            ]
        },
        {
            division: "AFC South",
            teams: [
                { rank: 3, name: "Jacksonville Jaguars", record: "13-4" },
                { rank: 5, name: "Houston Texans", record: "12-5" },
                { rank: 8, name: "Indianapolis Colts", record: "8-9" },
                { rank: 16, name: "Tennessee Titans", record: "3-14" }
            ]
        },
        {
            division: "AFC West",
            teams: [
                { rank: 1, name: "Denver Broncos", record: "14-3" },
                { rank: 7, name: "Los Angeles Chargers", record: "11-6" },
                { rank: 12, name: "Kansas City Chiefs", record: "6-11" },
                { rank: 14, name: "Las Vegas Raiders", record: "3-14" }
            ]
        }
    ];

    const afcConference = [];

    afcDivisions.forEach((divisionInfo) => {
        divisionInfo.teams.forEach((team) => {
            afcConference.push({
                rank: team.rank,
                name: team.name,
                record: team.record,
                division: divisionInfo.division
            });
        });
    });

    afcConference.sort((a, b) => a.rank - b.rank);

    return (
        <main id="nfl-page">
            <section id="conference-hero">
                <div id="conference-logo-side">
                    <img id="conference-corner-logo" src={afcLogo} alt="AFC logo" />
                </div>

                <div id="conference-hero-main">
                    <h2 id="quest">The American Football Conference</h2>
                    <h2 id="quest">(AFC)</h2>

                    <div id="nfl-buttons">
                        <section
                            className="nfl-button-box"
                            onClick={() => setShowPopup(true)}
                        >
                            <h2>Games</h2>
                        </section>

                        <Link to="/sports/football/afc/teams" className="nfl-link">
                            <section className="nfl-button-box">
                                <h2>Teams</h2>
                            </section>
                        </Link>
                    </div>
                </div>

                <div className="conference-hero-spacer"></div>
            </section>

            {showPopup && (
                <div className="popup-overlay" onClick={() => setShowPopup(false)}>
                    <div className="popup-box" onClick={(e) => e.stopPropagation()}>
                        <p>
                            The NFL schedule will be released in May 2026. The games page is not yet available.
                        </p>
                        <button onClick={() => setShowPopup(false)}>Close</button>
                    </div>
                </div>
            )}

            <section id="nfl-standings-section">
                <div id="nfl-standings-top">
                    <h3>2025 AFC Standings</h3>

                    <div id="nfl-view-buttons">
                        <button
                            className={standingsView === 'division' ? 'nfl-view-btn active-nfl-view' : 'nfl-view-btn'}
                            onClick={() => setStandingsView('division')}
                        >
                            By Division
                        </button>

                        <button
                            className={standingsView === 'conference' ? 'nfl-view-btn active-nfl-view' : 'nfl-view-btn'}
                            onClick={() => setStandingsView('conference')}
                        >
                            Full Conference
                        </button>
                    </div>
                </div>

                {standingsView === 'division' ? (
                    <div id="nfl-division-grid">
                        {afcDivisions.map((divisionInfo) => (
                            <div key={divisionInfo.division} className="nfl-division-box">
                                <h4>{divisionInfo.division}</h4>

                                <div className="nfl-team-list">
                                    {divisionInfo.teams.map((team, index) => (
                                        <Link
                                            key={team.name}
                                            to={getTeamPath(team.name)}
                                            className="nfl-team-row"
                                            style={{ textDecoration: 'none', color: 'inherit' }}
                                        >
                                            <div className="nfl-team-left">
                                                <span className="nfl-num">{index + 1}.</span>
                                                <img
                                                    src={AFCteamLogos[team.name]}
                                                    alt={team.name}
                                                    className="nfl-team-logo"
                                                />
                                                <span className="nfl-team-name">{team.name}</span>
                                            </div>

                                            <span className="nfl-record">{team.record}</span>
                                        </Link>
                                    ))}
                                </div>
                            </div>
                        ))}
                    </div>
                ) : (
                    <div className="nfl-conference-box">
                        <div className="nfl-conference-header">
                            <span>Rank</span>
                            <span></span>
                            <span>Team</span>
                            <span>Record</span>
                            <span className="nfl-division-col">Division</span>
                        </div>

                        {afcConference.map((team) => (
                            <Link
                                key={team.name}
                                to={getTeamPath(team.name)}
                                className="nfl-conference-row"
                                style={{ textDecoration: 'none', color: 'inherit' }}
                            >
                                <span className="nfl-conf-rank">{team.rank}</span>
                                <img
                                    src={AFCteamLogos[team.name]}
                                    alt={team.name}
                                    className="nfl-team-logo"
                                />
                                <span className="nfl-conf-team-name">{team.name}</span>
                                <span className="nfl-conf-record">{team.record}</span>
                                <span className="nfl-conf-division nfl-division-col">{team.division}</span>
                            </Link>
                        ))}
                    </div>
                )}
            </section>
        </main>
    );
};

export default AFChomePage;